export const ERR_OK = 200

export const baseURL = 'https://api.weelv.com'

export const weatherCode = {
  '1': '晴',
  '2': '晴',
  '3': '晴',
  '4': '多云',
  '5': '晴',
  '6': '多云',
  '7': '多云',
  '8': '阴',
  '11': '雾',
  '12': '阵雨',
  '13': '阵雨',
  '14': '阵雨',
  '15': '雷雨',
  '16': '雷雨',
  '17': '雷雨',
  '18': '雨',
  '19': '轻雪',
  '20': '轻雪',
  '21': '轻雪',
  '22': '雪',
  '23': '雪',
  '24': '冻雪',
  '25': '冰霰',
  '26': '冻雨',
  '29': '雨和雪',
  '30': '热',
  '31': '冷',
  '32': '风',
  '33': '晴',
  '34': '晴',
  '35': '多云',
  '36': '多云',
  '37': '晴',
  '38': '多云',
  '39': '阵雨',
  '40': '阵雨',
  '41': '雷雨',
  '42': '雷雨',
  '43': '阵雪',
  '44': '雪'
}
